import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http/http.service';
import { Path } from '../../../utils/constant/paths';

@Injectable({
  providedIn: 'root'
})
export class DeviceMaintenanceService {

  constructor(
    private http: HttpService,
  ) { }
    
  getList(data?: any) {
    return this.http.post(Path.DEVICE.GET_LIST, data);
  }
  
  getDetail(params?: any) {
    return this.http.get(Path.DEVICE.GET_DETAIL, params);
  }
  
  getLocations(data?: any) {
    return this.http.post(Path.DEVICE.GET_LOCATION, data);
  }
  
  insert(data?: any) {
    return this.http.post(Path.DEVICE.INSERT, data);
  }
  genericMaintenanceDownload(data?: any) {
    return this.http.post(Path.DOWNLOAD.DOWNLOAD_DEVICE_MAINTENACE, data);
  }
}